import {
  Header1,
  Instruction,
  ProgramContentType,
} from "data/BlockComponentV2";
import {
  ButtonGroup,
  CellType,
  DividerLine,
  Image,
  Textarea,
  TypographyLine,
} from "data/CellComponentV2";
import { ProgramType } from "data/programData";
import {
  createTaskEditorBlock,
  createTaskEditorButtonGroupOption,
  createTaskEditorCell,
  createTaskEditorLine,
  ensureTaskEditorLastCard,
  isTaskEditorLastCardBlock,
  isTaskEditorNestedBlockType,
  TaskEditorBlock,
  TaskEditorButtonGroupOption,
  TaskEditorCell,
  TaskEditorLine,
  TaskEditorTypographyStyle,
  TaskEditorState,
} from "./taskEditorUtils";

const TASK_EDITOR_PUBLISHED_STORAGE_KEY = "task-editor:published-tasks";
const TASK_EDITOR_DRAFT_STORAGE_KEY = "task-editor:working-draft";

export interface PublishedTaskEditorTask extends TaskEditorState {
  versionId: string;
  updatedAt: string;
}

const TASK_EDITOR_INITIAL_PUBLISHED_TASKS: PublishedTaskEditorTask[] = [
  {
    taskId: "test:1-2",
    title: "테스트1-2",
    setNumber: 1,
    isKeyActivity: false,
    versionId: "2026-03-13T09:26:02.704Z",
    updatedAt: "2026-03-13T09:26:02.704Z",
    blocks: [
      {
        id: "task-editor-block-qki69c2ra",
        type: "Header1",
        content: "Test 1-2",
      },
      {
        id: "task-editor-block-35sd1ngh1",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-22v4wtygj",
            type: "Typography",
            content: "안녕",
            typographyStyle: "Body",
          },
        ],
      },
      {
        id: "task-editor-block-r6xfi4zkx",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-4x85n7aod",
            type: "ButtonGroup",
            content: "",
            options: [
              {
                text: "A",
                showFromId: "task-editor-block-3ex3dqwre",
                showToId: "task-editor-block-hbfi24x9l",
                restartFromId: "task-editor-block-2vnuqyf5u",
              },
              {
                text: "B",
                showFromId: "task-editor-block-njk7xwo0s",
                showToId: "task-editor-block-3fwfln38i",
                restartFromId: "task-editor-block-2vnuqyf5u",
              },
            ],
          },
        ],
      },
      {
        id: "task-editor-block-3ex3dqwre",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-sf316t6k8",
            type: "Typography",
            content: "4",
            typographyStyle: "Body",
          },
        ],
      },
      {
        id: "task-editor-block-hbfi24x9l",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-c25hq3t8a",
            type: "Typography",
            content: "5",
            typographyStyle: "Body",
          },
        ],
      },
      {
        id: "task-editor-block-njk7xwo0s",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-gt8v5o2zo",
            type: "Typography",
            content: "6",
            typographyStyle: "Body",
          },
        ],
      },
      {
        id: "task-editor-block-3fwfln38i",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-bqlner3qo",
            type: "Typography",
            content: "7",
            typographyStyle: "Body",
          },
        ],
      },
      {
        id: "task-editor-block-2vnuqyf5u",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-2wp7ma2yt",
            type: "Typography",
            content: "8",
            typographyStyle: "Body",
          },
        ],
      },
      {
        id: "task-editor-last-card",
        type: "LastCard",
        content: "common:lastCard1\ncommon:lastCard2",
      },
    ],
  },
  {
    taskId: "test:1-1",
    title: "테스트1-1",
    setNumber: 1,
    isKeyActivity: true,
    versionId: "2026-03-13T09:26:02.704Z",
    updatedAt: "2026-03-13T09:26:02.704Z",
    blocks: [
      {
        id: "task-editor-block-fj9aq84t0",
        type: "Header1",
        content: "Test 1 활동지 입니다",
      },
      {
        id: "task-editor-block-vjcxk5sjp",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-ryse9miyq",
            type: "Typography",
            content: "안녕하세요",
            typographyStyle: "Body",
          },
        ],
      },
      {
        id: "task-editor-block-of473kelr",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-qvlxxwgr7",
            type: "Typography",
            content: "상황을 입력하세요",
            typographyStyle: "Body",
          },
          {
            id: "task-editor-line-srrrvx15b",
            type: "Typography",
            content: "상황",
            typographyStyle: "Label",
          },
          {
            id: "task-editor-line-a77m17nsh",
            type: "Textarea",
            content: "",
            textareaPlaceholder: "상황을 입력하세요",
          },
        ],
      },
      {
        id: "task-editor-block-ol1sxl9wj",
        type: "Instruction",
        content: "",
        lines: [
          {
            id: "task-editor-line-052kvnlkr",
            type: "Image",
            content:
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO6p7k8AAAAASUVORK5CYII=",
          },
        ],
      },
      {
        id: "task-editor-last-card",
        type: "LastCard",
        content: "common:lastCard1\ncommon:lastCard2",
      },
    ],
  },
];

function getStorage() {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage;
}

function getDefaultBlocks(blocks: TaskEditorBlock[]) {
  return blocks.length ? blocks : [createTaskEditorBlock("Instruction")];
}

function getNormalizedBlocks(blocks: TaskEditorBlock[]): TaskEditorBlock[] {
  return ensureTaskEditorLastCard(getDefaultBlocks(blocks));
}

function normalizeSetNumber(setNumber?: number) {
  if (typeof setNumber !== "number" || !Number.isFinite(setNumber)) {
    return undefined;
  }

  const normalizedSetNumber = Math.floor(setNumber);

  return normalizedSetNumber > 0 ? normalizedSetNumber : undefined;
}

function normalizeTaskEditorBlockType(type: string): TaskEditorBlock["type"] {
  switch (type) {
    case "Header1":
      return "Header1";
    case "LastCard":
      return "LastCard";
    default:
      return "Instruction";
  }
}

function isLegacyInstructionWithTextareaBlock(
  block: TaskEditorBlock | (TaskEditorBlock & { type: string })
) {
  return (block as { type: string }).type === "InstructionWithTextarea";
}

function isLegacyInstructionWithContentBlock(
  block: TaskEditorBlock | (TaskEditorBlock & { type: string })
) {
  return (block as { type: string }).type === "InstructionWithContent";
}

function getDefaultNormalizedLines(block: TaskEditorBlock) {
  if (isLegacyInstructionWithTextareaBlock(block)) {
    return [
      normalizeTaskEditorLine(
        {
          ...createTaskEditorLine("Textarea"),
          id: `${block.id}-line-0`,
          content: "",
        },
        0
      ),
    ];
  }

  return [normalizeTaskEditorLine(undefined, 0)];
}

function isMeaningfulTaskEditorLine(line: TaskEditorLine) {
  if (line.type === "Typography" || line.type === "Image") {
    return Boolean(line.content.trim());
  }

  return true;
}

function normalizeTaskEditorTypographyStyle(
  style: TaskEditorLine["typographyStyle"]
): TaskEditorTypographyStyle {
  switch (style) {
    case "Label":
      return "Label";
    case "Alert":
      return "Alert";
    case "Dimmed":
      return "Dimmed";
    default:
      return "Body";
  }
}

function normalizeTaskEditorButtonGroupOption(
  option: unknown
): TaskEditorButtonGroupOption {
  if (typeof option === "string") {
    return createTaskEditorButtonGroupOption({
      text: option.trim(),
    });
  }

  if (!option || typeof option !== "object") {
    return createTaskEditorButtonGroupOption();
  }

  const candidate = option as {
    text?: unknown;
    translationKey?: unknown;
    showFromId?: unknown;
    showToId?: unknown;
    restartFromId?: unknown;
    hideFromId?: unknown;
  };
  const nextText =
    typeof candidate.text === "string"
      ? candidate.text.trim()
      : typeof candidate.translationKey === "string"
        ? candidate.translationKey.trim()
        : "";
  const normalizedShowFromId =
    typeof candidate.showFromId === "string" ? candidate.showFromId.trim() : "";
  const normalizedShowToId =
    typeof candidate.showToId === "string" ? candidate.showToId.trim() : "";
  const normalizedRestartFromId =
    typeof candidate.restartFromId === "string"
      ? candidate.restartFromId.trim()
      : "";
  const normalizedHideFromId =
    typeof candidate.hideFromId === "string" ? candidate.hideFromId.trim() : "";

  return createTaskEditorButtonGroupOption({
    text: nextText,
    ...(normalizedShowFromId.length > 0
      ? { showFromId: normalizedShowFromId }
      : {}),
    ...(normalizedShowToId.length > 0 ? { showToId: normalizedShowToId } : {}),
    ...(normalizedRestartFromId.length > 0
      ? { restartFromId: normalizedRestartFromId }
      : {}),
    ...(normalizedHideFromId.length > 0
      ? { hideFromId: normalizedHideFromId }
      : {}),
  });
}

function getTaskEditorButtonGroupOptionBranchId(
  option: TaskEditorButtonGroupOption,
  key: "showFromId" | "showToId" | "restartFromId" | "hideFromId"
) {
  const value = (option as unknown as Record<string, unknown>)[key];
  return typeof value === "string" ? value.trim() : "";
}

function normalizeTaskEditorCell(
  cell: TaskEditorCell | undefined,
  cellIndex: number
): TaskEditorCell {
  if (!cell) {
    return {
      ...createTaskEditorCell(),
      id: `task-editor-cell-default-${cellIndex}`,
    };
  }

  const normalizedType =
    cell.type === "ButtonGroup"
      ? "ButtonGroup"
      : cell.type === "Textarea"
        ? "Textarea"
        : cell.type === "Image"
          ? "Image"
        : "Typography";

  return {
    ...cell,
    type: normalizedType,
    content: typeof cell.content === 'string' ? cell.content.trim() : '',
    width:
      typeof cell.width === "number" && Number.isFinite(cell.width)
        ? cell.width
        : 1,
    ...(normalizedType === "ButtonGroup"
      ? {
          options:
            Array.isArray(cell.options) && cell.options.length > 0
              ? cell.options.map((option) =>
                  normalizeTaskEditorButtonGroupOption(option)
                )
              : [
                  createTaskEditorButtonGroupOption(),
                  createTaskEditorButtonGroupOption(),
                ],
        }
      : {
          options: undefined,
        }),
    ...(normalizedType === "Textarea"
      ? {
          textareaPlaceholder:
            typeof cell.textareaPlaceholder === "string"
              ? cell.textareaPlaceholder
              : "",
        }
      : {
          textareaPlaceholder: undefined,
        }),
  };
}

function isLegacyTaskEditorLine(line: TaskEditorLine | undefined) {
  return Boolean(line && "cells" in line && Array.isArray((line as TaskEditorLine & { cells?: unknown }).cells));
}

function normalizeTaskEditorLine(
  line: TaskEditorLine | undefined,
  lineIndex: number
): TaskEditorLine {
  if (!line) {
    return {
      ...createTaskEditorLine(),
      id: `task-editor-line-default-${lineIndex}`,
    };
  }

  if (isLegacyTaskEditorLine(line)) {
    const cells = (line as TaskEditorLine & { cells?: TaskEditorCell[] }).cells;
    const primaryCell = normalizeTaskEditorCell(
      Array.isArray(cells) && cells.length > 0 ? cells[0] : undefined,
      0
    );

    return {
      id: line.id,
      type: primaryCell.type,
      content: primaryCell.content.trim(),
      ...(primaryCell.type === "ButtonGroup"
        ? {
            options:
              primaryCell.options && primaryCell.options.length > 0
                ? primaryCell.options.map((option) =>
                    normalizeTaskEditorButtonGroupOption(option)
                  )
                : [
                    createTaskEditorButtonGroupOption(),
                    createTaskEditorButtonGroupOption(),
                  ],
          }
        : {}),
      ...(primaryCell.type === "Textarea"
        ? {
            textareaPlaceholder: primaryCell.textareaPlaceholder ?? "",
          }
        : {}),
      ...(primaryCell.type === "Typography"
        ? {
            typographyStyle: normalizeTaskEditorTypographyStyle(
              line.typographyStyle
            ),
          }
        : {}),
    };
  }

  const normalizedType =
    line.type === "ButtonGroup"
      ? "ButtonGroup"
      : line.type === "Textarea"
        ? "Textarea"
        : line.type === "Image"
          ? "Image"
        : "Typography";

  return {
    id: line.id,
    type: normalizedType,
    content: line.content.trim(),
    ...(normalizedType === "ButtonGroup"
      ? {
          options:
            Array.isArray(line.options) && line.options.length > 0
              ? line.options.map((option) =>
                  normalizeTaskEditorButtonGroupOption(option)
                )
              : [
                  createTaskEditorButtonGroupOption(),
                  createTaskEditorButtonGroupOption(),
                ],
        }
      : {
          options: undefined,
        }),
    ...(normalizedType === "Textarea"
      ? {
          textareaPlaceholder:
            typeof line.textareaPlaceholder === "string"
              ? line.textareaPlaceholder
              : "",
        }
      : {
          textareaPlaceholder: undefined,
        }),
    ...(normalizedType === "Typography"
      ? {
          typographyStyle: normalizeTaskEditorTypographyStyle(
            line.typographyStyle
          ),
        }
      : {
          typographyStyle: undefined,
        }),
  };
}

export function normalizeTaskEditorState(
  state: TaskEditorState
): TaskEditorState {
  return {
    taskId: state.taskId.trim(),
    title: state.title.trim(),
    setNumber: normalizeSetNumber(state.setNumber),
    isKeyActivity: state.isKeyActivity === true,
    blocks: getNormalizedBlocks(state.blocks).map((block): TaskEditorBlock => {
      if (isTaskEditorLastCardBlock(block)) {
        return block;
      }

      const normalizedType = normalizeTaskEditorBlockType(block.type);

      return {
        ...block,
        type: normalizedType,
        content: block.content.trim(),
        ...(isTaskEditorNestedBlockType(normalizedType)
          ? {
              lines:
                block.lines && block.lines.length > 0
                  ? block.lines.map((line, lineIndex) =>
                      normalizeTaskEditorLine(line, lineIndex)
                    )
                  : getDefaultNormalizedLines(block),
            }
          : {
              lines: undefined,
            }),
      };
    }),
  };
}

function createProgramContentLines(block: TaskEditorBlock): CellType[][] {
  const lines = Array.isArray(block.lines) && block.lines.length > 0
    ? block.lines
    : [createTaskEditorLine()];

  return lines.map((line) => {
    if (!line) {
      return TypographyLine('');
    }

    if (line.type === "ButtonGroup") {
      const options = Array.isArray(line.options) && line.options.length > 0
        ? line.options
        : [createTaskEditorButtonGroupOption(), createTaskEditorButtonGroupOption()];
      return [
        ButtonGroup(
          options.map((option) => {
            const normalizedOption = normalizeTaskEditorButtonGroupOption(option);
            const showFromId = getTaskEditorButtonGroupOptionBranchId(
              normalizedOption,
              "showFromId"
            );
            const showToId = getTaskEditorButtonGroupOptionBranchId(
              normalizedOption,
              "showToId"
            );
            const restartFromId = getTaskEditorButtonGroupOptionBranchId(
              normalizedOption,
              "restartFromId"
            );
            const hideFromId = getTaskEditorButtonGroupOptionBranchId(
              normalizedOption,
              "hideFromId"
            );

            return {
              text: normalizedOption.text.trim(),
              showFromId,
              showToId,
              restartFromId,
              hideFromId,
            };
          }),
          { id: typeof line.content === 'string' ? line.content.trim() : '' }
        ),
      ];
    }

    if (line.type === "Textarea") {
      return [
        Textarea({
          id: typeof line.content === "string" ? line.content.trim() : "",
          placeholder:
            typeof line.textareaPlaceholder === "string"
              ? line.textareaPlaceholder
              : "",
        }),
      ];
    }

    if (line.type === "Image") {
      return [Image(typeof line.content === "string" ? line.content.trim() : "")];
    }

    const isLabel = line.typographyStyle === "Label";
    const isAlert = line.typographyStyle === "Alert";
    const isDimmed = line.typographyStyle === "Dimmed";

    return TypographyLine(
      typeof line.content === "string" ? line.content.trim() : "",
      {
        isLabel,
        isAlert,
        isDimmed,
      }
    );
  });
}

const HARDCODED_LAST_CARD_TEXT_1 =
  "이번 활동은 어땠나요? 느낀 점이나 어려웠던 점, 걱정되는 점을 편하게 말씀해주세요. 없다면 화살표를 눌러 다음으로 넘어가 주세요.";
const HARDCODED_LAST_CARD_TEXT_2 = "활동을 마쳤어요. [마치기]를 눌러주세요";

function createProgramBlocks(block: TaskEditorBlock): ProgramContentType[] {
  if (isTaskEditorLastCardBlock(block)) {
    return [
      {
        blockId: "feedback",
        lines: [
          [{ type: "typography" as const, content: { text: HARDCODED_LAST_CARD_TEXT_1 } }],
          [{ type: "feedback" as const, content: {} }],
        ],
      },
      {
        lines: [
          [{ type: "typography" as const, content: { text: HARDCODED_LAST_CARD_TEXT_2 } }],
        ],
      },
    ];
  }

  switch (block.type) {
    case "Header1":
      return [Header1(block.content, { blockId: block.id })];
    default:
      const normalizedLines = (Array.isArray(block.lines) ? block.lines : []).filter((line) =>
        isMeaningfulTaskEditorLine(line)
      );
      const title = typeof block.content === 'string' ? block.content.trim() : '';
      const contentLines = normalizedLines.length
        ? normalizedLines.map((line) => {
            const programLines = createProgramContentLines({ ...block, lines: [line] });
            return Array.isArray(programLines) && programLines.length > 0 ? programLines[0] : TypographyLine('');
          })
        : !title
          ? [TypographyLine("")]
          : [];

      return [
        {
          blockId: block.id,
          lines: [
            ...(title
              ? Instruction(title, { blockId: block.id }).lines
              : []),
            ...(title &&
            normalizedLines.length > 0 &&
            isLegacyInstructionWithContentBlock(block)
              ? [DividerLine()]
              : []),
            ...contentLines,
          ],
        },
      ];
  }
}

function setFirstBlockShown(content: ProgramContentType[]) {
  if (!content.length) {
    return content;
  }

  return content.map((block, index) =>
    index === 0
      ? {
          ...block,
          isShown: true,
        }
      : block
  );
}

function setAllBlocksShown(content: ProgramContentType[]) {
  return content.map((block) => ({
    ...block,
    isShown: true,
  }));
}

function isTaskEditorButtonGroupOptionValue(value: unknown) {
  if (typeof value === "string") {
    return true;
  }

  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as {
    text?: unknown;
    showFromId?: unknown;
    showToId?: unknown;
    restartFromId?: unknown;
    hideFromId?: unknown;
  };

  return (
    (candidate.text === undefined || typeof candidate.text === "string") &&
    (candidate.showFromId === undefined ||
      typeof candidate.showFromId === "string") &&
    (candidate.showToId === undefined || typeof candidate.showToId === "string") &&
    (candidate.restartFromId === undefined ||
      typeof candidate.restartFromId === "string") &&
    (candidate.hideFromId === undefined ||
      typeof candidate.hideFromId === "string")
  );
}

function isTaskEditorBlock(value: unknown): value is TaskEditorBlock {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as TaskEditorBlock;

  return (
    typeof candidate.id === "string" &&
    typeof candidate.type === "string" &&
    typeof candidate.content === "string" &&
    (candidate.lines === undefined ||
      (Array.isArray(candidate.lines) &&
        candidate.lines.every((line) => {
          if (!line || typeof line !== "object") {
            return false;
          }

          const nextLine = line as TaskEditorLine & {
            label?: unknown;
            cells?: unknown;
          };

          if (Array.isArray(nextLine.cells)) {
            return (
              typeof nextLine.id === "string" &&
              typeof nextLine.type === "string" &&
              (nextLine.label === undefined || typeof nextLine.label === "string") &&
              nextLine.cells.every(
                (cell) =>
                  Boolean(cell) &&
                  typeof cell === "object" &&
                  typeof (cell as TaskEditorCell).id === "string" &&
                  typeof (cell as TaskEditorCell).type === "string" &&
                  typeof (cell as TaskEditorCell).content === "string" &&
                  (typeof (cell as TaskEditorCell).options === "undefined" ||
                    (Array.isArray((cell as TaskEditorCell).options) &&
                      (cell as TaskEditorCell).options?.every(
                        (option) => isTaskEditorButtonGroupOptionValue(option)
                      )))
              )
            );
          }

          return (
            typeof nextLine.id === "string" &&
            typeof nextLine.type === "string" &&
            typeof nextLine.content === "string" &&
            (typeof nextLine.options === "undefined" ||
              (Array.isArray(nextLine.options) &&
                nextLine.options.every((option) =>
                  isTaskEditorButtonGroupOptionValue(option)
                )))
          );
        })))
  );
}

function isTaskEditorState(value: unknown): value is TaskEditorState {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as TaskEditorState;

  return (
    typeof candidate.taskId === "string" &&
    typeof candidate.title === "string" &&
    (candidate.setNumber === undefined || typeof candidate.setNumber === "number") &&
    (candidate.isKeyActivity === undefined ||
      typeof candidate.isKeyActivity === "boolean") &&
    Array.isArray(candidate.blocks) &&
    candidate.blocks.every(isTaskEditorBlock)
  );
}

function toPublishedTaskEditorTask(value: unknown) {
  if (!isTaskEditorState(value)) {
    return undefined;
  }

  const normalizedState = normalizeTaskEditorState(value);
  const candidate = value as PublishedTaskEditorTask;

  if (typeof candidate.updatedAt !== "string") {
    return undefined;
  }

  return {
    ...normalizedState,
    updatedAt: candidate.updatedAt,
    versionId:
      typeof candidate.versionId === "string" ? candidate.versionId : candidate.updatedAt,
  };
}

function parsePublishedTasks(
  rawValue: string | null
): PublishedTaskEditorTask[] {
  if (!rawValue) {
    return [];
  }

  try {
    const parsed = JSON.parse(rawValue);

    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map((task) => toPublishedTaskEditorTask(task))
      .filter((task): task is PublishedTaskEditorTask => Boolean(task));
  } catch (error) {
    return [];
  }
}

function getTaskEditorInitialPublishedTasks() {
  return TASK_EDITOR_INITIAL_PUBLISHED_TASKS.map((task) => {
    const normalizedState = normalizeTaskEditorState(task);

    return {
      ...normalizedState,
      versionId: task.versionId,
      updatedAt: task.updatedAt,
    };
  });
}

export function ensureTaskEditorPublishedTasksSeeded() {
  const storage = getStorage();

  if (!storage) {
    return;
  }

  const hasPublishedTasksKey =
    storage.getItem(TASK_EDITOR_PUBLISHED_STORAGE_KEY) !== null;

  if (hasPublishedTasksKey) {
    return;
  }

  storage.setItem(
    TASK_EDITOR_PUBLISHED_STORAGE_KEY,
    JSON.stringify(getTaskEditorInitialPublishedTasks())
  );
}

export function buildTaskEditorProgram(
  state: TaskEditorState,
  options?: { showAllBlocks?: boolean }
): ProgramType {
  const normalizedState = normalizeTaskEditorState(state);
  const content = (options?.showAllBlocks ? setAllBlocksShown : setFirstBlockShown)(
    normalizedState.blocks.flatMap(createProgramBlocks)
  );

  return {
    taskId: normalizedState.taskId || "NEW-TASK-ID",
    title: normalizedState.title || "새 Task 제목",
    setNumber: normalizedState.setNumber,
    isKeyActivity: normalizedState.isKeyActivity,
    content,
  };
}

export function getPublishedTaskEditorTasks(): PublishedTaskEditorTask[] {
  const storage = getStorage();

  if (!storage) {
    return [];
  }

  return parsePublishedTasks(
    storage.getItem(TASK_EDITOR_PUBLISHED_STORAGE_KEY)
  ).sort((left, right) => right.updatedAt.localeCompare(left.updatedAt));
}

export function getPublishedTaskEditorTask(taskId: string) {
  const normalizedTaskId = taskId.trim();

  if (!normalizedTaskId) {
    return undefined;
  }

  return getPublishedTaskEditorTasks().find(
    (task) => task.taskId === normalizedTaskId
  );
}

export function getPublishedTaskEditorProgram(taskId: string) {
  const task = getPublishedTaskEditorTask(taskId);

  return task ? buildTaskEditorProgram(task) : undefined;
}

export function getPublishedTaskEditorTitle(taskId: string) {
  return getPublishedTaskEditorTask(taskId)?.title;
}

export function isPublishedTaskEditorTaskIdTaken(
  taskId: string,
  currentTaskId?: string
) {
  const normalizedTaskId = taskId.trim();

  if (!normalizedTaskId) {
    return false;
  }

  const normalizedCurrentTaskId = currentTaskId?.trim();

  return getPublishedTaskEditorTasks().some(
    (task) =>
      task.taskId === normalizedTaskId && task.taskId !== normalizedCurrentTaskId
  );
}

export function savePublishedTaskEditorTask(
  state: TaskEditorState,
  currentTaskId?: string
) {
  const storage = getStorage();

  if (!storage) {
    return undefined;
  }

  const normalizedState = normalizeTaskEditorState(state);
  const versionTimestamp = new Date().toISOString();
  const publishedTask: PublishedTaskEditorTask = {
    ...normalizedState,
    taskId: normalizedState.taskId || "NEW-TASK-ID",
    title: normalizedState.title || "새 Task 제목",
    versionId: versionTimestamp,
    updatedAt: versionTimestamp,
  };
  const normalizedCurrentTaskId = currentTaskId?.trim();

  const otherTasks = getPublishedTaskEditorTasks().filter(
    (task) =>
      task.taskId !== publishedTask.taskId &&
      task.taskId !== normalizedCurrentTaskId
  ).map((task) => {
    if (
      publishedTask.isKeyActivity === true &&
      publishedTask.setNumber !== undefined &&
      task.setNumber === publishedTask.setNumber &&
      task.isKeyActivity === true
    ) {
      return {
        ...task,
        isKeyActivity: false,
      };
    }

    return task;
  });

  storage.setItem(
    TASK_EDITOR_PUBLISHED_STORAGE_KEY,
    JSON.stringify([publishedTask, ...otherTasks])
  );

  return publishedTask;
}

export function removePublishedTaskEditorTask(taskId: string) {
  const storage = getStorage();

  if (!storage) {
    return;
  }

  const normalizedTaskId = taskId.trim();

  storage.setItem(
    TASK_EDITOR_PUBLISHED_STORAGE_KEY,
    JSON.stringify(
      getPublishedTaskEditorTasks().filter(
        (task) => task.taskId !== normalizedTaskId
      )
    )
  );
}

export function saveTaskEditorWorkingDraft(state: TaskEditorState) {
  const storage = getStorage();

  if (!storage) {
    return;
  }

  storage.setItem(
    TASK_EDITOR_DRAFT_STORAGE_KEY,
    JSON.stringify(normalizeTaskEditorState(state))
  );
}

export function getTaskEditorWorkingDraft() {
  const storage = getStorage();

  if (!storage) {
    return undefined;
  }

  try {
    const rawValue = storage.getItem(TASK_EDITOR_DRAFT_STORAGE_KEY);

    if (!rawValue) {
      return undefined;
    }

    const parsed = JSON.parse(rawValue);

    return isTaskEditorState(parsed) ? parsed : undefined;
  } catch (error) {
    return undefined;
  }
}
